import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, of } from 'rxjs';
import { onDeleteCompanyFailed } from '../../../../../../aumico-lib-companies-fe/src/lib';
import { DeleteState } from '../../../../../../aumico-lib-companies-fe/src/lib/pages/edit-company/edit-company.component';
import { AddOrEditCompanyPage } from './add-edit-company.page';

@UntilDestroy()
@Component({
    selector: 'app-page-edit-company2.page',
    templateUrl: 'add-edit-company2.page.html',
    styleUrls: ['add-edit-company.page.scss'],
})
export class AddOrEditCompanyPage2 extends AddOrEditCompanyPage {
    showDeleteConfirmationDialog: boolean = false;
    showDisableConfirmationDialog: boolean = false;
    isDeleteInProgress: boolean = false;
    deleteState: DeleteState = DeleteState.IDLE;

    override ngOnInit(): void {
        super.ngOnInit();
        this.initDeleteOperationListeners();
    }

    private initDeleteOperationListeners(): void {
        // Listen for delete company operation completion (success or failure)
        this.companiesProvider
            .getDeleteCompanyResult$()
            .pipe(untilDestroyed(this))
            .subscribe((result) => {
                if (result.type === onDeleteCompanyFailed.type) {
                    // result.payload is typed as HttpErrorResponse

                    const error = result.payload;
                    if (error.status === 409) {
                        this.fireErrorMessage(
                            'aumico_company_delete_failed_because_of_conf_notification_message',
                            'aumico_company_delete_failed_because_of_conf_notification_title',
                        );
                    } else {
                        this.fireErrorMessage(
                            'aumico_unknown_error',
                            'aumico_company_delete_failed_because_of_conf_notification_title',
                        );
                    }
                    // Handle error case
                }
            });
    }

    deleteCompany() {
        this.showDeleteConfirmationDialog = true;
    }

    changeStatus(toActive: boolean) {
        if (!toActive) {
            this.showDisableConfirmationDialog = true;
        } else {
            this.companiesProvider.dispatchUpdateCompanyStatus(true, this.activeCompany._id);
        }
    }

    onDeleteConfirmationDialogClosed(confirmed: boolean): void {
        this.showDeleteConfirmationDialog = false;
        if (confirmed) {
            // Set delete state to prevent form validation and navigation guard interference
            this.isDeleteInProgress = true;

            // Dispatch the delete action
            this.companiesProvider.dispatchDeleteCompany(this.activeCompany._id);
        }
    }

    onDisableConfirmationDialogClosed(confirmed: boolean): void {
        this.showDisableConfirmationDialog = false;
        if (confirmed) {
            this.companiesProvider.dispatchUpdateCompanyStatus(false, this.activeCompany._id);
        }
    }

    public onLogoUploaded(file: File): void {
        this.logoHasChanged = true;
        this.uploadedFile = file;
    }

    protected override isDataChanged(): Observable<boolean> {
        // Skip data change detection during delete to prevent save changes popup
        if (this.isDeleteInProgress) {
            return of(false);
        }
        if (this.deleteState === DeleteState.COMPLETED) {
            return of(false);
        }
        return super.isDataChanged();
    }

    override canDeactivate(): Observable<boolean> {
        // Skip navigation guard entirely during delete operations
        if (this.isDeleteInProgress) {
            return of(true);
        }
        return super.canDeactivate();
    }

    onDeletingStateChange(state: DeleteState): void {
        this.deleteState = state;
        if (state < DeleteState.IN_PROGRESS) {
            this.isDeleteInProgress = false;
        } else {
            this.isDeleteInProgress = true;
        }
    }
}
